// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3xE-Q","dragIcon":"Choice_dragIcon__3nivZ","left":"Choice_left__3b63A","input":"Choice_input__3sq-N"};